module.exports = __webpack_public_path__ + "static/me-81480fb74ada792a22ff2271ddec16f1.jpg";